module.exports = __webpack_public_path__ + "static/media/details-1.30f89587.jpeg";